<textarea [name]="currentQuestion.GUID" rows="4" [(ngModel)]="currentValue" (keyup)="updateCurrentAnswer()"
    class="text-box mt-4" ></textarea>